import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-copy_2_line",
  "use": "vab-icon-copy_2_line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-copy_2_line\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 2C7.89543 2 7 2.89543 7 4V6H9V4H20V15H18V17H20C21.1046 17 22 16.1046 22 15V4C22 2.89543 21.1046 2 20 2H9ZM4 7C2.89543 7 2 7.89543 2 9V20C2 21.1046 2.89543 22 4 22H15C16.1046 22 17 21.1046 17 20V9C17 7.89543 16.1046 7 15 7H4ZM4 9H15V20H4V9Z\" fill=\"#09244B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol